export enum ReservaAction {
  Crear = 0,
  Modificar = 1,
  Anular = 2,
  Completar = 3,
  Archivar = 4,
}
export enum NvvAction {
  SoloReserva = 0,
  CreaFromRes = 1,
  Anular = 2,
  Crear = 3,
  Modificar = 4,
  Aprobar = 5,
}
export enum ConsignaAction {
  Anular = 2,
}
export enum CotizaAction {
  Anular = 2,
}

export enum PurchaseAction {
  Crear = 0,
  Modificar = 1,
  Anular = 2,
}
